import React from 'react';
import yup from '../../../utility/yup';
import { Loadable } from '../../../store/types';
import { Order } from '../../../types/items';
import { ItemFormReact } from '../../../components';
import ProjectOrderFormFields from './ProjectOrdersTable/ProjectOrderFormFields';
import { VideoOrderForm } from '../../../store/modules/orders/types';
import { transformOrderToVideoOrderForm } from '../../../utility/orders';

const orderSchema = yup.object({
  options: yup.object({
    order_title: yup.lazy((value) => (!value ? yup.string()
      : yup.string().matches(/^[\p{Alpha}\s+(.\-`'&)]+$/u, 'Title has a wrong symbols'))),
    format: yup.object({
      standard: yup.boolean(),
      square: yup.boolean(),
      portrait: yup.boolean(),
    }),
  }),
  scene_id: yup.number().min(1, 'Script is required').label('Script'),
}).test(
  'options.format',
  '',
  (obj) => {
    if (obj.options.format.standard || obj.options.format.square || obj.options.format.portrait) {
      return true;
    }

    throw new yup.ValidationError(
      'You must choose format',
      null,
      'options.format.standard',
    );
  },
);

type Props = {
  creatingMode?: boolean;
  record: Loadable<Order>;
  onSubmit: (data: VideoOrderForm) => void;
};

const ProjectOrderForm = ({
  record: { loading, data },
  onSubmit,
}: Props) => {
  const canEdit = data?.permissions.can_edit || false;

  const initialValues: VideoOrderForm = transformOrderToVideoOrderForm(data as Order);

  return (
    <ItemFormReact
      creatingMode={false}
      initialValues={initialValues}
      validationSchema={orderSchema}
      onSubmit={onSubmit}
      loading={loading}
      editPermitted={Boolean(canEdit)}
      preventCancelChanges
    >
      <ProjectOrderFormFields />
    </ItemFormReact>
  );
};

export default ProjectOrderForm;
